<template>
  <div class="shows">
    <PageHeading title="Sendungen" />
    <BlockContent :content="showsContentTop" modifier="wide" />
    <div class="shows__filter">
      <Filter>
        <template #search>
          <input v-model="filter.search" type="search" placeholder="Suche">
        </template>
        <template #language>
          <select v-model="filter.language">
            <option v-for="language in filterData.languages.items" :key="language.id" :value="language.id">
              {{ language.name }}
            </option>
          </select>
        </template>
        <template #category>
          <select v-model="filter.tag">
            <option v-for="tag in filterData.tags.items" :key="tag.id" :value="tag.id">
              {{ tag.name }}
            </option>
          </select>
        </template>
      </Filter>
    </div>
    <PageContent>
      <section class="shows__content">
        <ol class="shows__list">
          <li v-for="show in items" :key="show.uuid" class="shows__item">
            <ShowTeaser :show="show" />
          </li>
          <div v-if="!items.length" class="shows__empty">
            Keine Sendung zur Filtereinstellung.
          </div>
        </ol>
      </section>
    </PageContent>
    <Pager
      :is-first-page
      :is-last-page
      :current-page
      :page-count
      @prev="prev"
      @next="next"
      @page-select="onPageSelect"
    />
  </div>
</template>

<script setup lang="ts">

const appConfig = useAppConfig()

const items = ref([])
const total = ref(0)
const pageSize = appConfig.defaultPageSizeGrid

const filter = ref({
  search: '',
  language: '',
  tag: ''
})

const filterQuery = computed(() => {
  return {
    search: filter.value.search,
    languages: [filter.value.language],
    tags: [filter.value.tag],
    searchEnabled: filter.value.search !== '',
    languagesEnabled: filter.value.language !== '',
    tagsEnabled: filter.value.tag !== ''
  }
})

const { data: filterData } = await useAsyncData('programmeFilter', async () => {
  const data = await useGraphqlQuery('programmeFilter').then((v) => {
    return v.data
  })

  data.languages?.items.unshift({
    id: '',
    name: 'Alle Sprachen'
  })

  data.tags?.items.unshift({
    id: '',
    name: 'Alle Tags'
  })
  return data
})

const { start, finish } = useLoadingIndicator()

const {
  currentPage,
  pageCount,
  isFirstPage,
  isLastPage,
  prev,
  next,
  offset,
  onPageSelect
} = await usePaginatedFilteredQuery(total, pageSize, fetchData, filterQuery)

async function fetchData (setData: Boolean = true) {
  start()
  return await useGraphqlQuery('shows', {
    limit: pageSize,
    offset: offset.value,
    ...filterQuery.value
  }).then((v) => {
    // @todo: refactor this: move to usePaginatedFilteredQuery?
    if (setData) {
      items.value = v.data.shows.items
      total.value = v.data.shows.total
    }
    finish()
    return v.data.shows
  })
}

const { data } = await useAsyncData('shows', async () => {
  return await fetchData(false)
})

items.value = data.value.items
total.value = data.value.total

const { data: showsContentTop } = await useGetContentBlock('0b1253ed-db35-4cf6-9d0c-1fd6e01de410', 'showsContentTop')

useSeoMeta({
  title: 'Sendungen'
})
</script>

<style lang="scss">
@use "~/assets/sass/tools";

.shows {
  &__filter {
    margin-top: var(--space--xl);
    @include tools.to(tools.$breakpoint--desktop) {
      margin-top: var(--grid-gutter);
    }
  }

  &__content {
    margin-top: var(--space--xxl);
  }

  &__list {
    @include tools.grid($columns: 3);
    margin: 0;
    margin-bottom: var(--space--xxl);
    padding-left: 0;
    @include tools.to(tools.$breakpoint--desktop) {
      @include tools.grid($columns: 2);
    }
    @include tools.to(tools.$breakpoint--mobile) {
      @include tools.grid($columns: 1);
      row-gap: calc(var(--grid-gutter) * 2);
    }
  }

  &__item {
    margin-top: 0;
    padding-left: 0;
    list-style: none;
  }
}
</style>
